import React, {useState} from 'react'
import styled from 'styled-components'
import getYouTubeID from 'get-youtube-id'
import {Box} from 'app/Components/Layout'
import {PlainText, useI18n} from 'plugins/i18n'
import {twMerge} from 'tailwind-merge'

const Wrapper = styled(Box).attrs({relative: true})`
	padding-bottom: 56.25%;
	overflow: hidden;
`
const Video = styled.iframe.attrs({
	frameBorder: 0,
	allowFullScreen: true,
	allow:
		'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
})`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: black;
`
const PlaceHolder = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	display: flex;
	align-items: center;
	justify-content: center;

	cursor: pointer;
	overflow: hidden;

	box-shadow: 0px 3em 4em rgba(0, 0, 0, 0.62) inset;

	&:hover {
		background-color: white;
		opacity: 0.5;
	}

	background-image: url('https://img.youtube.com/vi/${p =>
		p.videoId}/sddefault.jpg');
	background-position: center;
	background-size: cover;
`
const Title = styled.div`
	position: absolute;
	z-index: 2;
	left: 1em;
	top: 1em;
	float: left;
	font-weight: bold;
	font-size: 80%;
	color: white;
	text-shadow: 1px 1px black;
	font-family: 'Open Sans', sans-serif;
`

const YoutubeSection: React.FC<{
	readonly value: {
		url: string
		titleI18n?: any
		minHeight?: number
	}
	readonly className?: string
}> = ({value: {url, titleI18n, minHeight}, className}) => {
	const {lang} = useI18n()
	const [isLoaded, setIsLoaded] = useState(false)
	const videoId = getYouTubeID(url) || url

	if (!videoId)
		return (
			<div className="flex w-full items-center justify-center">
				Please provide a Youtube Id
			</div>
		)

	return (
		<div
			className={'flex w-full items-center justify-center'}
			style={minHeight ? {minHeight: `${minHeight}rem`} : undefined}
		>
			<Wrapper className={className}>
				{isLoaded ? (
					<Video
						src={`https://www.youtube.com/embed/${videoId}?autoplay=1&&hl=${lang}&rel=0`}
					/>
				) : (
					<PlaceHolder onClick={() => setIsLoaded(true)} videoId={videoId}>
						{!!titleI18n && <PlainText i18n={titleI18n} Component={Title} />}
						<svg height="80" width="80" viewBox="0 0 48 48">
							<path d="M16 10v28l22-14z" fill="white" opacity="0.54" />
						</svg>
					</PlaceHolder>
				)}
			</Wrapper>
		</div>
	)
}
export default YoutubeSection
